import Head from "next/head";
import { MenuId } from "../components/Header";
import Layout from "../components/Layout";
import PublicSearch from "../components/PublicSearch";
import { RusContextProps, RusAuthProps, SearchJson, Photo } from "../lib/definitions";
import styles from './new-video-search.module.scss'
import {Space, Text} from '@mantine/core'
import EmailSignupBanner from "../components/EmailSignupBanner";
import { GetServerSideProps } from "next";
import { DateTime } from "luxon";
import { getJWTTokenFromUser, getUserInformation } from "../lib/data";
      import { getAuth, buildClerkProps } from '@clerk/nextjs/server'
import { getClerkHeader } from "../lib/common";
import { auth } from '@clerk/nextjs/server';

type Data = {
    images : Photo [],
    dateProcessed: string,
    count: number
      }
      
export default function ImageSearch (props: RusContextProps & RusAuthProps)
{
    return (
        <Layout menuId={MenuId.imageSearch}>



        <Head>
            <title>Image search</title>
            <meta name="description" content="Over 3,000 image references for artists, focussing on portrait and figure, searchable by pose, model characteristic, and more."></meta>
        </Head>
        <div className = {styles.mainContent}>
        <h1>Image search</h1>
        <Text mb='sm'>We have some 3,000 high quality, high resolution reference photos for artists. You can search by model age, gender and pose type.</Text>
        <Text mb='sm'><b>NEW! We now have landscape and still life photos. Just change the image category below.</b></Text>

        <PublicSearch searchType="image" {...props}/>
        </div>
        <Space h='md'/>
        <EmailSignupBanner/>
        </Layout>
        );
        }


        export const getServerSideProps: GetServerSideProps<{ data: Data }> = async (context) => {

            // get the pinned video first time it's loaded too

            //let dtFrom = DateTime.now().toUTC().minus({hour:1}).startOf('minute');
            //let dtTo = dtFrom.plus({day:14});
            //console.log("Getting clerk server side props for image search page");
            const { getToken } = getAuth(context.req);
            const clerkToken = await getToken();
            
            //console.log("Is authenticated:", isAuthenticated, "User ID:", userId);

            let dtNow = DateTime.now().toUTC();
        
            let search : SearchJson =
            {
                SubjectType:"Human",
                ReferenceType:"Human",
                Count: 50,
                Offset: 0
            }

            let {model, category} = context.query;

            if (model)
            {
                search.ModelId = +model;
            }

            let categoryType = '';
        
            switch((category as string)?.toLowerCase())
            {
                case 'human':
                    categoryType=search.SubjectType=search.ReferenceType='Human';
                    break;
                case 'animal':
                    categoryType=search.SubjectType=search.ReferenceType='Animal';
                    break;
                case 'stilllife':
                    categoryType=search.SubjectType=search.ReferenceType='StillLife';
                    break;
                case 'landscape':
                    categoryType=search.SubjectType=search.ReferenceType='Landscape';
                    break;        
    
            }
                              
            let json = encodeURIComponent(JSON.stringify(search, (_, v) => { if (v != null) return v; }));
        
            let user = await getUserInformation(context.req);

            let token;
        
            if (user.subscribed)
            {
                token = await getJWTTokenFromUser(user);
            }
        
            let options = { 
                method: 'GET',  cache: "no-store" as RequestCache,
                headers: {... token?{'auth-token': token}:{}, ...getClerkHeader( clerkToken)} as HeadersInit
            };

        
            let url = process.env.ADMIN_ROUTE + '/imagesearch?json=' + json;
        
            let at2 =  await fetch(url, options);

            let j = (await at2.json());

            let images = j.photos as Photo [];
                    
            let count : number = j.count;
 
            return {
              props: {
                data : {
                images: images,
                modelId:model?model:0,
                count: count,
                dateProcessed: dtNow.toISO(),
                category: categoryType
                }
              },
            }
          }
        
        